// Generated by ReScript, PLEASE EDIT WITH CARE

import * as JsxRuntime from "react/jsx-runtime";
import * as BsCssJs$PrezzeeRibbon from "../../../bindings/BsCss/BsCssJs.bs.js";
import * as Theme__Color$PrezzeeRibbon from "../../../theme/Theme__Color.bs.js";

var profileMenuSection = BsCssJs$PrezzeeRibbon.style([
      BsCssJs$PrezzeeRibbon.borderWidth(BsCssJs$PrezzeeRibbon.zero),
      BsCssJs$PrezzeeRibbon.padding(BsCssJs$PrezzeeRibbon.px(7)),
      BsCssJs$PrezzeeRibbon.nthChild({
            NAME: "add",
            VAL: [
              1,
              2
            ]
          }, [
            BsCssJs$PrezzeeRibbon.borderTopWidth(BsCssJs$PrezzeeRibbon.px(1)),
            BsCssJs$PrezzeeRibbon.borderStyle(BsCssJs$PrezzeeRibbon.solid),
            BsCssJs$PrezzeeRibbon.borderTopColor(Theme__Color$PrezzeeRibbon.Personal.paleGrey)
          ])
    ]);

var Styles = {
  profileMenuSection: profileMenuSection
};

function ProfileMenu__Section(props) {
  return JsxRuntime.jsx("div", {
              children: props.children,
              className: profileMenuSection
            });
}

var make = ProfileMenu__Section;

export {
  Styles ,
  make ,
}
/* profileMenuSection Not a pure module */
